import React, { useEffect, useRef, useState } from 'react';
import { Bell } from 'lucide-react';

import { notificationService } from '../services/notificationService';
import AdminNotificationsPopup from './AdminNotificationsPopup';

export default function AdminNotificationsBell({ isAdmin }) {
  const [open, setOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchMyCount = async () => {
    try {
      const res = await notificationService.getMy();
      const items = res?.data || res || [];
      const count = Array.isArray(items) ? items.filter((n) => !n.isRead).length : 0;
      setUnreadCount(count);
    } catch (e) {
      // silent: bell badge should not break the header
      console.error(e);
    }
  };

  useEffect(() => {
    if (!isAdmin) return;
    fetchMyCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  const buttonRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    const onMouseDown = (e) => {
      const btn = buttonRef.current;
      if (!btn) return;
      if (btn.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onMouseDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [open]);

  if (!isAdmin) return null;

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={() => setOpen((o) => !o)}
        className="relative rounded-2xl border border-slate-200 bg-white p-2.5 shadow-sm transition hover:border-purple-300 hover:bg-purple-50"
        aria-label="Open notifications"
      >
        <Bell size={18} className="text-slate-600" />
        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[9px] font-bold text-white">
            {unreadCount}
          </span>
        )}
      </button>

      <AdminNotificationsPopup
        open={open}
        onClose={() => {
          setOpen(false);
          fetchMyCount();
        }}
      />
    </div>
  );
}

